// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_maxspeed_above40: MapboxStyleLayer[] = [
  {
    layout: {
      'line-cap': 'round',
    },
    filter: ['>=', ['get', 'maxspeed'], 40],
    type: 'line',
    id: 'maxspeed-groessergleich40',
    paint: {
      'line-opacity': 0.98,
      'line-color': [
        'interpolate',
        ['linear'],
        ['get', 'maxspeed'],
        40,
        '#eeb449',
        50,
        '#fc7c40',
        60,
        '#e92d07',
        80,
        '#b80505',
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 11, 0.5, 15, 1],
    },
  },
  {
    layout: {
      'line-cap': 'round',
    },
    filter: ['>=', ['get', 'maxspeed'], 40],
    type: 'line',
    id: 'hitarea-maxspeed40',
    paint: {
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
      'line-opacity': 0,
      'line-color': 'rgb(216, 20, 255)',
    },
  },
]
